import React from 'react'

interface IconProps {
  className?: string
}

const Gantt01 = ({ className }: IconProps) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M11 10C11.9319 10 12.3978 10 12.7654 9.84776C13.2554 9.64477 13.6448 9.25542 13.8478 8.76537C14 8.39782 14 7.93188 14 7C14 6.06812 14 5.60218 13.8478 5.23463C13.6448 4.74458 13.2554 4.35523 12.7654 4.15224C12.3978 4 11.9319 4 11 4L5 4C4.06812 4 3.60218 4 3.23463 4.15224C2.74458 4.35523 2.35523 4.74458 2.15224 5.23463C2 5.60218 2 6.06812 2 7C2 7.93188 2 8.39782 2.15224 8.76537C2.35523 9.25542 2.74458 9.64477 3.23463 9.84776C3.60218 10 4.06812 10 5 10L11 10Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M19 20C19.9319 20 20.3978 20 20.7654 19.8478C21.2554 19.6448 21.6448 19.2554 21.8478 18.7654C22 18.3978 22 17.9319 22 17C22 16.0681 22 15.6022 21.8478 15.2346C21.6448 14.7446 21.2554 14.3552 20.7654 14.1522C20.3978 14 19.9319 14 19 14H10C9.06812 14 8.60218 14 8.23463 14.1522C7.74458 14.3552 7.35523 14.7446 7.15224 15.2346C7 15.6022 7 16.0681 7 17C7 17.9319 7 18.3978 7.15224 18.7654C7.35523 19.2554 7.74458 19.6448 8.23463 19.8478C8.60218 20 9.06812 20 10 20L19 20Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default Gantt01
